export const PLAYERS_CARDS_V2: string[] = ['first_yellow_cards', 'yellow_cards', 'red_cards', 'total_cards'];

export const PLAYERS_CARDS: string[] = ['firstYellowCards', 'yellowCards', 'redCards', 'totalCards'];
